import { ReactNode } from "react";

export const Badge = ({ children }: { children: ReactNode | string }) => {
  return <span className="rounded-md bg-red-100 px-3 py-2 text-xs text-black">{children}</span>;
};
